var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSummary({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.602,
    height: 19.6,
    viewBox: "0 0 19.602 19.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3226",
    "data-name": "Group 3226",
    transform: "translate(-309.199 -489.198)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8488",
    "data-name": "Path 8488",
    d: "M4.273,9.982a.8.8,0,0,1-.8-.8A5.715,5.715,0,0,1,9.182,3.473a.8.8,0,1,1,0,1.6A4.114,4.114,0,0,0,5.073,9.182.8.8,0,0,1,4.273,9.982Z",
    transform: "translate(309 489)",
    fill: "#52ff02"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_32",
    "data-name": "Union 32",
    d: "M17388.234,13281.367l-3.5-3.5a8.987,8.987,0,1,1,1.133-1.132l3.494,3.494a.8.8,0,0,1,0,1.135.806.806,0,0,1-1.131,0Zm-16.633-10.387a7.377,7.377,0,0,0,12.355,5.451.781.781,0,0,1,.473-.472,7.38,7.38,0,1,0-12.828-4.979Z",
    transform: "translate(-17060.801 -12772.801)",
    fill: "#16161a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummary);
export default __webpack_public_path__ + "static/media/summary.85778ac0dbb324d936c019ecf692d5a3.svg";
export { ForwardRef as ReactComponent };